import { render, staticRenderFns } from "./TextAlignBottomIcon.vue?vue&type=template&id=624d0f58&"
import script from "./TextAlignBottomIcon.vue?vue&type=script&lang=js&"
export * from "./TextAlignBottomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports